import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import "./assest_design/Proquote.css";
import logo from "./assets/procode_za_logo.jpg";

/* ===========================
   PRICING CONFIG
=========================== */

const PRICING = {
  platform: {
    web: { individual: 555.56, small: 4000, medium: 22000, enterprise: 39000 },
    android: { individual: 2500, small: 6000, medium: 15000, enterprise: 28000 },
    ios: { individual: 3500, small: 9000, medium: 19000, enterprise: 32000 },
    cross: { individual: 5000, small: 18000, medium: 32000, enterprise: 55000 },
    linux: { individual: 3000, small: 8000, medium: 26000, enterprise: 48000 },
    windows: { individual: 3000, small: 7500, medium: 24000, enterprise: 45000 },
    ecommerce: { individual: 4500, small: 12000, medium: 28000, enterprise: 52000 },
    dashboard: { individual: 2500, small: 8500, medium: 21000, enterprise: 40000 },
    internalPortal: { individual: 3000, small: 12000, medium: 26000, enterprise: 48000 },
  },

  features: {
    login: 1000,
    registration: 900,
    roleAccess: 1600,
    profileManagement: 1200,
    passwordReset: 700,
    twoFactorAuth: 1800,
    pushNotification: 1200,
    smsNotification: 1600,
    emailAutomation: 1400,
    uploads: 1500,
    mediaGallery: 1300,
    booking: 2000,
    appointmentScheduling: 1800,
    chat: 3500,
    liveChatSupport: 2800,
    payments: 3200,
    subscriptions: 2800,
    invoicing: 2200,
    quotationSystem: 2400,
    analytics: 3300,
    reporting: 2400,
    customDashboard: 3500,
    adminpanel: 4200,
    staffManagement: 2600,
    crmTools: 3200,
    inventoryManagement: 3800,
    orderManagement: 3000,
    documentManagement: 2600,
    approvalWorkflow: 2900,
    auditLogs: 2000,
    offlineMode: 2800,
    realtimeSync: 3200,
    apiIntegration: 3800,
    thirdPartyIntegration: 3500,
    mapIntegration: 1800,
    geolocationTracking: 2800,
    multiLanguage: 1800,
    searchAndFilter: 1400,
    advancedSearch: 2200,
    securityHardening: 3500,
    cloudDeployment: 4200,
    monitoring: 2600,
    ciCd: 3000,
    backupRecovery: 2200,
    seoSetup: 1800,
    blogCms: 1800,
    landingPages: 1600,
    contactForms: 900,
    leadCapture: 1800,
    referralSystem: 2200,
    loyaltyRewards: 2400,
    ticketingSupport: 2600,
    learningModules: 3500,
    certificates: 1800,
    forumCommunity: 2400,
    whiteLabel: 4200,
    multiTenant: 5500,
  },

  aiSolutions: {
    aiChatbot: 4500,
    recommendationEngine: 6500,
    predictiveAnalytics: 8500,
    mlModelTraining: 12000,
    computerVision: 15000,
    nlpAssistant: 9000,
    anomalyDetection: 8500,
    forecastingEngine: 7800,
    smartAutomation: 6200,
    aiReporting: 4800,
  },

  electronics: {
    iotBasic: 8500,
    embeddedFirmware: 12000,
    industrialAutomation: 22000,
    edgeAi: 28000,
    hardwareIntegration: 16000,
    sensorNetwork: 14000,
    roboticsControl: 24000,
    smartMonitoring: 15000,
    gpsTrackingHardware: 12500,
    customElectronicsPrototype: 18000,
  },

  branding: {
    logoIdentity: 2200,
    brandGuidelines: 3500,
    pitchDeckDesign: 2800,
    socialMediaPack: 2000,
    brochureDesign: 1800,
    productCatalogue: 2200,
    presentationDesign: 1600,
    uiBrandStyling: 2600,
    seoContentSupport: 2800,
    campaignAssets: 2400,
    prCommsSupport: 2600,
    launchContentPack: 2200,
    websiteCopySupport: 2400,
    socialMediaStrategy: 2800,
    profileDocumentPack: 1800,
    proposalDesignSupport: 2000,
  },

  existingSystems: {
    systemAuditReview: 2800,
    existingSystemTakeover: 4500,
    featureEnhancement: 3500,
    bugFixingStabilisation: 2600,
    uiRefreshExistingSystem: 3000,
    integrationIntoExistingSystem: 3800,
    performanceOptimisation: 3200,
    technicalCleanupRefactor: 4200,
    handoverDocumentation: 2400,
    legacySystemModernisation: 6500,
  },

  support: {
    standard: 0,
    business: 0.12,
    premium: 0.25,
  },

  multiplier: {
    individual: 1,
    small: 1,
    medium: 1.15,
    enterprise: 1.3,
  },
};

const LABELS = {
  platform: {
    web: "Website / Web Platform",
    android: "Android App",
    ios: "iOS App",
    cross: "Cross-Platform App",
    linux: "Linux Platform",
    windows: "Windows Platform",
    ecommerce: "E-commerce Platform",
    dashboard: "Analytics Dashboard",
    internalPortal: "Internal Portal / Business System",
  },
  features: {
    login: "User Login",
    registration: "User Registration",
    roleAccess: "Role-Based Access",
    profileManagement: "Profile Management",
    passwordReset: "Password Reset",
    twoFactorAuth: "Two-Factor Authentication",
    pushNotification: "Push Notifications",
    smsNotification: "SMS Notifications",
    emailAutomation: "Email Automation",
    uploads: "File Uploads",
    mediaGallery: "Media Gallery",
    booking: "Booking System",
    appointmentScheduling: "Appointment Scheduling",
    chat: "Internal Chat",
    liveChatSupport: "Live Chat Support",
    payments: "Online Payments",
    subscriptions: "Subscriptions",
    invoicing: "Invoicing",
    quotationSystem: "Quotation System",
    analytics: "Analytics",
    reporting: "Reporting",
    customDashboard: "Custom Dashboard",
    adminpanel: "Admin Panel",
    staffManagement: "Staff Management",
    crmTools: "CRM Tools",
    inventoryManagement: "Inventory Management",
    orderManagement: "Order Management",
    documentManagement: "Document Management",
    approvalWorkflow: "Approval Workflow",
    auditLogs: "Audit Logs",
    offlineMode: "Offline Mode",
    realtimeSync: "Real-Time Sync",
    apiIntegration: "API Integration",
    thirdPartyIntegration: "Third-Party Integration",
    mapIntegration: "Map Integration",
    geolocationTracking: "Geolocation Tracking",
    multiLanguage: "Multi-Language Support",
    searchAndFilter: "Search & Filter",
    advancedSearch: "Advanced Search",
    securityHardening: "Security Hardening",
    cloudDeployment: "Cloud Deployment",
    monitoring: "Monitoring",
    ciCd: "CI/CD Setup",
    backupRecovery: "Backup & Recovery",
    seoSetup: "SEO Setup",
    blogCms: "Blog / CMS",
    landingPages: "Landing Pages",
    contactForms: "Contact Forms",
    leadCapture: "Lead Capture",
    referralSystem: "Referral System",
    loyaltyRewards: "Loyalty & Rewards",
    ticketingSupport: "Ticketing / Support Desk",
    learningModules: "Learning Modules",
    certificates: "Certificates",
    forumCommunity: "Forum / Community",
    whiteLabel: "White-Label Support",
    multiTenant: "Multi-Tenant Architecture",
  },
  aiSolutions: {
    aiChatbot: "AI Chatbot",
    recommendationEngine: "Recommendation Engine",
    predictiveAnalytics: "Predictive Analytics",
    mlModelTraining: "ML Model Training",
    computerVision: "Computer Vision",
    nlpAssistant: "NLP Assistant",
    anomalyDetection: "Anomaly Detection",
    forecastingEngine: "Forecasting Engine",
    smartAutomation: "Smart Automation",
    aiReporting: "AI Reporting",
  },
  electronics: {
    iotBasic: "Basic IoT Build",
    embeddedFirmware: "Embedded Firmware",
    industrialAutomation: "Industrial Automation",
    edgeAi: "Edge AI",
    hardwareIntegration: "Hardware Integration",
    sensorNetwork: "Sensor Network",
    roboticsControl: "Robotics Control",
    smartMonitoring: "Smart Monitoring",
    gpsTrackingHardware: "GPS Tracking Hardware",
    customElectronicsPrototype: "Custom Electronics Prototype",
  },
  branding: {
    logoIdentity: "Logo & Brand Identity",
    brandGuidelines: "Brand Guidelines",
    pitchDeckDesign: "Pitch Deck Design",
    socialMediaPack: "Social Media Pack",
    brochureDesign: "Brochure Design",
    productCatalogue: "Product Catalogue",
    presentationDesign: "Presentation Design",
    uiBrandStyling: "UI Brand Styling",
    seoContentSupport: "SEO Content Support",
    campaignAssets: "Campaign Assets",
    prCommsSupport: "PR & Communication Support",
    launchContentPack: "Launch Content Pack",
    websiteCopySupport: "Website Copy Support",
    socialMediaStrategy: "Social Media Strategy",
    profileDocumentPack: "Profile Document Pack",
    proposalDesignSupport: "Proposal Design Support",
  },
  existingSystems: {
    systemAuditReview: "Existing System Audit & Review",
    existingSystemTakeover: "Existing System Takeover",
    featureEnhancement: "Feature Enhancements",
    bugFixingStabilisation: "Bug Fixing & Stabilisation",
    uiRefreshExistingSystem: "UI Refresh for Existing System",
    integrationIntoExistingSystem: "Integration into Existing System",
    performanceOptimisation: "Performance Optimisation",
    technicalCleanupRefactor: "Technical Cleanup & Refactor",
    handoverDocumentation: "Handover Documentation",
    legacySystemModernisation: "Legacy System Modernisation",
  },
};

function getLabel(group, key) {
  return LABELS[group]?.[key] || key.replace(/([A-Z])/g, " $1");
}

export default function ProQuote() {
  const [showModal, setShowModal] = useState(true);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [size, setSize] = useState("individual");
  const [platform, setPlatform] = useState("web");
  const [features, setFeatures] = useState([]);
  const [aiSolutions, setAiSolutions] = useState([]);
  const [electronics, setElectronics] = useState([]);
  const [branding, setBranding] = useState([]);
  const [existingSystems, setExistingSystems] = useState([]);
  const [support, setSupport] = useState("standard");
  const [vat, setVat] = useState(false);
  const [referral, setReferral] = useState(false);
  const [podProgramme, setPodProgramme] = useState(false);

  useEffect(() => {
    document.title =
      "Software, App & Website Development Pricing in South Africa | ProQuote by ProCode ZA";

    const setMeta = (name, content, property = false) => {
      const selector = property
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
      let tag = document.querySelector(selector);

      if (!tag) {
        tag = document.createElement("meta");
        if (property) {
          tag.setAttribute("property", name);
        } else {
          tag.setAttribute("name", name);
        }
        document.head.appendChild(tag);
      }

      tag.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Estimate custom software development, app development, website development, dashboards, AI solutions, IoT projects, branding, marketing support, existing system upgrades and technical support pricing in Johannesburg, Cape Town, Durban and across South Africa with ProQuote by ProCode ZA."
    );
    setMeta(
      "keywords",
      "software development pricing South Africa, app development pricing South Africa, website development pricing South Africa, Johannesburg software company pricing, Cape Town app development quote, Durban website development quote, dashboard development pricing South Africa, AI development pricing South Africa, branding pricing South Africa, existing system support pricing South Africa, ProCode ZA quote"
    );
    setMeta(
      "og:title",
      "Software, App & Website Development Pricing in South Africa | ProQuote by ProCode ZA",
      true
    );
    setMeta(
      "og:description",
      "Transparent pricing estimates for software, app development, websites, dashboards, AI, IoT, branding, marketing support and system upgrades in Johannesburg, Cape Town, Durban and across South Africa.",
      true
    );
  }, []);

  const toggle = (list, setList, value) => {
    setList((prev) =>
      prev.includes(value) ? prev.filter((x) => x !== value) : [...prev, value]
    );
  };

  const getFeatureTotal = () => {
    let featureTotal = 0;

    features.forEach((f) => {
      featureTotal += PRICING.features[f];
    });

    aiSolutions.forEach((a) => {
      featureTotal += PRICING.aiSolutions[a];
    });

    electronics.forEach((e) => {
      featureTotal += PRICING.electronics[e];
    });

    branding.forEach((b) => {
      featureTotal += PRICING.branding[b];
    });

    existingSystems.forEach((s) => {
      featureTotal += PRICING.existingSystems[s];
    });

    return featureTotal;
  };

  const total = () => {
    const basePrice = PRICING.platform[platform][size];
    const rawFeatureTotal = getFeatureTotal();
    const discountedFeatureTotal = podProgramme
      ? rawFeatureTotal * 0.85
      : rawFeatureTotal;

    let sum = basePrice + discountedFeatureTotal;

    sum *= PRICING.multiplier[size];
    sum *= 1 + PRICING.support[support];

    if (referral) sum *= 0.9;
    if (vat) sum *= 1.15;

    return Math.round(sum);
  };

  const exportPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");

    const imgProps = pdf.getImageProperties(logo);
    const logoWidth = 28;
    const logoHeight = (imgProps.height * logoWidth) / imgProps.width;

    pdf.addImage(logo, "PNG", 10, 10, logoWidth, logoHeight);

    pdf.setFontSize(16);
    pdf.text("ProQuote Project Estimate", 190, 18, { align: "right" });

    pdf.setFontSize(9);
    pdf.setTextColor(120);
    pdf.text(`Generated: ${new Date().toLocaleDateString()}`, 190, 24, {
      align: "right",
    });

    let y = 40;

    pdf.setFontSize(10);
    pdf.setTextColor(0);
    pdf.text("Item", 10, y);
    pdf.text("Qty", 125, y);
    pdf.text("Unit (R)", 150, y);
    pdf.text("Total (R)", 190, y, { align: "right" });
    pdf.line(10, y + 2, 200, y + 2);
    y += 8;

    const rows = [];
    let featureSubtotal = 0;

    const basePrice = PRICING.platform[platform][size];

    rows.push({
      name: `${getLabel("platform", platform)} (${size})`,
      price: basePrice,
      isBase: true,
    });

    features.forEach((f) => {
      rows.push({
        name: getLabel("features", f),
        price: PRICING.features[f],
      });
      featureSubtotal += PRICING.features[f];
    });

    aiSolutions.forEach((a) => {
      rows.push({
        name: getLabel("aiSolutions", a),
        price: PRICING.aiSolutions[a],
      });
      featureSubtotal += PRICING.aiSolutions[a];
    });

    electronics.forEach((e) => {
      rows.push({
        name: getLabel("electronics", e),
        price: PRICING.electronics[e],
      });
      featureSubtotal += PRICING.electronics[e];
    });

    branding.forEach((b) => {
      rows.push({
        name: getLabel("branding", b),
        price: PRICING.branding[b],
      });
      featureSubtotal += PRICING.branding[b];
    });

    existingSystems.forEach((s) => {
      rows.push({
        name: getLabel("existingSystems", s),
        price: PRICING.existingSystems[s],
      });
      featureSubtotal += PRICING.existingSystems[s];
    });

    let subtotal = 0;

    rows.forEach((r) => {
      if (y > 260) {
        pdf.addPage();
        y = 20;
      }

      pdf.setFontSize(9);
      pdf.text(r.name, 10, y);
      pdf.text("1", 128, y);
      pdf.text(r.price.toLocaleString(), 165, y, { align: "right" });
      pdf.text(r.price.toLocaleString(), 190, y, { align: "right" });
      subtotal += r.price;
      y += 7;
    });

    pdf.line(10, y, 200, y);
    y += 8;

    const adjustments = [];

    if (podProgramme) {
      const podDiscount = featureSubtotal * 0.15;
      adjustments.push({
        label: "POD Programme Discount (Features Only)",
        value: -podDiscount,
      });
      subtotal -= podDiscount;
    }

    if (PRICING.multiplier[size] !== 1) {
      const multiplierUplift = subtotal * (PRICING.multiplier[size] - 1);
      adjustments.push({
        label: `${size.charAt(0).toUpperCase() + size.slice(1)} Complexity Uplift`,
        value: multiplierUplift,
      });
      subtotal += multiplierUplift;
    }

    if (support !== "standard") {
      const uplift = subtotal * PRICING.support[support];
      adjustments.push({
        label: `${support.charAt(0).toUpperCase() + support.slice(1)} Support`,
        value: uplift,
      });
      subtotal += uplift;
    }

    if (referral) {
      const discount = subtotal * 0.1;
      adjustments.push({
        label: "Referral Discount",
        value: -discount,
      });
      subtotal -= discount;
    }

    if (vat) {
      const vatAmount = subtotal * 0.15;
      adjustments.push({
        label: "VAT (15%)",
        value: vatAmount,
      });
      subtotal += vatAmount;
    }

    adjustments.forEach((a) => {
      if (y > 270) {
        pdf.addPage();
        y = 20;
      }

      pdf.text(a.label, 10, y);
      const formatted = a.value < 0
        ? `- ${Math.abs(a.value).toFixed(2)}`
        : a.value.toFixed(2);
      pdf.text(formatted, 190, y, { align: "right" });
      y += 6;
    });

    pdf.line(10, y, 200, y);
    y += 8;

    pdf.setFontSize(12);
    pdf.text("Total Estimated Cost", 10, y);
    pdf.text(`R ${Math.round(subtotal).toLocaleString()}`, 190, y, {
      align: "right",
    });

    pdf.setFontSize(7);
    pdf.setTextColor(130);
    pdf.text(
      `This estimate is indicative and subject to scope validation, technical consultation and final project discovery.
POD Programme applies 15% off selected features and add-ons only, not the base platform.
Feature quantities are assumed as one implementation per selected feature.
Existing system support, takeovers and legacy upgrades may require technical review.
© ${new Date().getFullYear()} ProCode ZA`,
      10,
      285
    );

    pdf.save("ProCode-ProQuote.pdf");
  };

  return (
    <section className="proquote-section">
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-card fade-up">
            <h2>Before You Continue</h2>

            <p>
              ProQuote gives you a{" "}
              <strong>transparent, obligation-free estimate</strong> for
              software, app development, websites, branding, marketing support,
              AI, IoT and system upgrades for businesses in South Africa.
            </p>

            <ul>
              <li>• Pricing shown is indicative and built for scoping clarity</li>
              <li>• This estimator improves over time using real project patterns</li>
              <li>• Selected features are estimated once per feature type</li>
              <li>• AI, IoT and embedded builds may require technical consultation</li>
              <li>• Existing system takeovers and upgrades may require technical review</li>
              <li>• Have a cheaper quote? Bring it — we’ll <strong>match or beat it</strong> where possible</li>
            </ul>

            <label className="modal-checkbox">
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={() => setAcceptedTerms(!acceptedTerms)}
              />
              I understand and agree to the Terms & Conditions
            </label>

            <button
              className="cta-primary"
              disabled={!acceptedTerms}
              onClick={() => setShowModal(false)}
            >
              Continue to ProQuote
            </button>
          </div>
        </div>
      )}

      <div
        className={`proquote-container ${showModal ? "blurred" : ""} fade-in`}
        id="proquote-pdf"
      >
        <div className="proquote-hero">
          <h2>Instant Project Estimate for South African Businesses</h2>

          <p className="proquote-intro">
            Estimate the cost of custom software development, app development,
            website development, dashboards, AI solutions, branding support,
            marketing support, automation workflows, IoT projects and existing
            system upgrades for businesses in Johannesburg, Cape Town, Durban
            and across South Africa.
          </p>
        </div>

        <div className="quote-block slide-up">
          <h3>Company Size</h3>
          <p className="block-intro">
            Choose the client type that best reflects your project scale and
            expected delivery complexity.
          </p>

          <div className="pill-group">
            {["individual", "small", "medium", "enterprise"].map((s) => (
              <button
                key={s}
                className={`pill ${size === s ? "active" : ""}`}
                onClick={() => setSize(s)}
              >
                {s === "individual" && "Individual / Starter"}
                {s === "small" && "Small Business"}
                {s === "medium" && "Medium Business"}
                {s === "enterprise" && "Enterprise"}
              </button>
            ))}
          </div>

          <div className="trust-strip">
            <div>
              <strong>Transparent South African pricing</strong>
              <span>Built for realistic project scoping and decision-making.</span>
            </div>
            <div>
              <strong>Support available long after launch</strong>
              <span>Long-term support applies to qualifying development solutions.</span>
            </div>
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>Platform Type</h3>
          <p className="block-intro">
            Select the primary solution type you want priced.
          </p>

          <div className="pill-group">
            {Object.keys(PRICING.platform).map((p) => (
              <button
                key={p}
                className={`pill ${platform === p ? "active" : ""}`}
                onClick={() => setPlatform(p)}
              >
                {getLabel("platform", p)}
              </button>
            ))}
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>Core Software Features</h3>
          <p className="block-intro">
            Add every feature your website, system, dashboard or platform may need.
          </p>

          <div className="feature-grid">
            {Object.keys(PRICING.features).map((f) => (
              <label
                key={f}
                className={`feature-tile ${features.includes(f) ? "selected" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={features.includes(f)}
                  onChange={() => toggle(features, setFeatures, f)}
                />
                {getLabel("features", f)}
              </label>
            ))}
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>AI, Machine Learning & Intelligent Automation</h3>
          <p className="block-intro">
            Add advanced intelligent features for smarter business systems and digital products.
          </p>

          <div className="feature-grid">
            {Object.keys(PRICING.aiSolutions).map((a) => (
              <label
                key={a}
                className={`feature-tile ${aiSolutions.includes(a) ? "selected" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={aiSolutions.includes(a)}
                  onChange={() => toggle(aiSolutions, setAiSolutions, a)}
                />
                {getLabel("aiSolutions", a)}
              </label>
            ))}
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>IoT, Robotics & Hardware Solutions</h3>
          <p className="block-intro">
            For smart devices, embedded systems, industrial builds and intelligent hardware integration.
          </p>

          <div className="feature-grid">
            {Object.keys(PRICING.electronics).map((e) => (
              <label
                key={e}
                className={`feature-tile ${electronics.includes(e) ? "selected" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={electronics.includes(e)}
                  onChange={() => toggle(electronics, setElectronics, e)}
                />
                {getLabel("electronics", e)}
              </label>
            ))}
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>Branding, Marketing & Presentation Support</h3>
          <p className="block-intro">
            Add visual, communication and market-facing support services that strengthen your launch, brand, public presence and client-facing material.
          </p>

          <div className="feature-grid">
            {Object.keys(PRICING.branding).map((b) => (
              <label
                key={b}
                className={`feature-tile ${branding.includes(b) ? "selected" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={branding.includes(b)}
                  onChange={() => toggle(branding, setBranding, b)}
                />
                {getLabel("branding", b)}
              </label>
            ))}
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>Existing System Support, Takeover & Feature Expansion</h3>
          <p className="block-intro">
            Choose these if you are not building from scratch and need us to improve, stabilise, support or expand an existing website, system or platform.
          </p>

          <div className="feature-grid">
            {Object.keys(PRICING.existingSystems).map((s) => (
              <label
                key={s}
                className={`feature-tile ${existingSystems.includes(s) ? "selected" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={existingSystems.includes(s)}
                  onChange={() => toggle(existingSystems, setExistingSystems, s)}
                />
                {getLabel("existingSystems", s)}
              </label>
            ))}
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>Support Tier</h3>
          <p className="block-intro">
            Choose your preferred post-build or ongoing support level.
          </p>

          <div className="pill-group">
            {["standard", "business", "premium"].map((s) => (
              <button
                key={s}
                className={`pill ${support === s ? "active" : ""}`}
                onClick={() => setSupport(s)}
              >
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="quote-block slide-up">
          <h3>Commercial Options</h3>
          <p className="block-intro">
            Apply available pricing options and benefits to refine your estimate.
          </p>

          <div className="pill-group">
            <button
              className={`pill ${vat ? "active" : ""}`}
              onClick={() => setVat(!vat)}
            >
              Include VAT
            </button>

            <button
              className={`pill ${referral ? "active" : ""}`}
              onClick={() => setReferral(!referral)}
            >
              Referral Discount (10% Off)
            </button>

            <button
              className={`pill ${podProgramme ? "active" : ""}`}
              onClick={() => setPodProgramme(!podProgramme)}
            >
              POD Programme (15% Off Features)
            </button>
          </div>
        </div>

        <div className="quote-total pulse-soft">
          <span>Estimated Project Cost</span>
          <h3>R {total().toLocaleString()}</h3>
          <p className="quote-note">
            Final pricing depends on confirmed scope, technical review,
            integrations, deployment complexity, support requirements and
            whether an existing system needs to be audited or stabilised first
            for businesses in South Africa.
          </p>
        </div>

        <div className="hero-actions">
          <button className="cta-primary" onClick={exportPDF}>
            Download PDF Estimate
          </button>
          <button
            className="cta-outline"
            onClick={() => (window.location.href = "/contact")}
          >
            Speak to a Specialist
          </button>
        </div>
      </div>
    </section>
  );
}